module.exports = __webpack_public_path__ + "svg/heart-red.svg?3bf3f20b300336d49a0dd964d27f6ac4";